export const formatPrice = (price) => {
    let p = price
    if (Number.isNaN(p) === true) {
        return 0
    }
    if (Number.isInteger(p) === false) {
        p = Math.round(p)
    }
    return (p / 100).toFixed(2).toLocaleString() 
}

export const parsePrice = (string) => {
    return Math.round(Number.parseFloat(string) * 100)
}

export const validatePrice = (price) => {
    return /^(0|[1-9]+[0-9]*)(\.[0-9]{0,2})?$/.test(price)
}